<div class="All-cards" *ngIf="busStopsDetails && busStopsDetails.length > 0">

    <!-- Start and End Location Detail -->
    <div class="d-flex flex-dir-rol just-space" style="margin-bottom: 8px;padding-left: 16px;">
        <span class="h-16 font-b office-color" style="white-space: break-spaces;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 290px;" misToolTip [text]="busStopsDetails[startStopIndex]?.address">
            {{busStopsDetails[startStopIndex]?.address}} </span>
        <span *ngIf="tripStatus==='Started'" class="h-14 font-b eta-color"
            style="margin-right:10px;height: 22px;max-width: 120px;">ETA:
            {{busStopsDetails[lastStopIndex].formattedPlannedArrivalTime}}</span>
        <span *ngIf="tripStatus==='Ended'" class="h-14 font-b eta-color-ended"
            style="margin-right:10px;height: 22px;max-width: 120px;">ENDED AT: {{actualEndTimeTrip}}</span>
    </div>
    <!-- - <span class="h6 grey">{{busStopsDetails[lastStopIndex].address}}</span> -->


    <!-- FIRST STOP CARD -->
    <div class="d-flex flex-dir-col" style="padding-left:10px ;"
        [ngClass]="currentStopIndex == startStopIndex?'highlight-stop':''">
        <div [ngStyle]="{ 'height': busStopsDetails[startStopIndex].stopContext == 'OFFICE' ? '80px' : '80px' }"
            class="stop-card d-flex" [ngClass]="currentStopIndex == startStopIndex?'highlight-stop':''">
            <!-- <div class="stop-card-child1">
                <span *ngIf="busStopsDetails[startStopIndex].stopContext == 'OFFICE'" class="h8">Office</span>
                <span *ngIf="busStopsDetails[startStopIndex].stopContext != 'OFFICE'" class="h8">Stop
                    {{busStopsDetails[startStopIndex].index}}</span>
            </div> -->
            <div class="stop-card-child2">
                <img *ngIf="currentStopIndex != startStopIndex && busStopsDetails[startStopIndex].stopContext == 'OFFICE' && busStopsDetails[startStopIndex]?.actualArrivalTime == 0 "
                    [src]="imgSrc + 'assets/icons/stop1-not-crossed-office1.svg'">
                <img *ngIf="currentStopIndex != startStopIndex && busStopsDetails[startStopIndex].stopContext == 'OFFICE' && busStopsDetails[startStopIndex]?.actualArrivalTime != 0 "
                    [src]="imgSrc + 'assets/icons/stop1-crossed-office1.svg'">
                <img *ngIf="currentStopIndex != startStopIndex && busStopsDetails[startStopIndex].stopContext != 'OFFICE' && busStopsDetails[startStopIndex]?.actualArrivalTime == 0 "
                    [src]="imgSrc + 'assets/icons/stop1-not-crossed1.svg'">
                <img *ngIf="currentStopIndex != startStopIndex && busStopsDetails[startStopIndex].stopContext != 'OFFICE' && busStopsDetails[startStopIndex]?.actualArrivalTime != 0 && !busStopsDetails[startStopIndex].skipped "
                    [src]="imgSrc + 'assets/icons/stop1-crossed.svg'">
                <img *ngIf="currentStopIndex != startStopIndex && busStopsDetails[startStopIndex].stopContext != 'OFFICE' && busStopsDetails[startStopIndex]?.actualArrivalTime != 0 && busStopsDetails[startStopIndex].skipped "
                    [src]="imgSrc + 'assets/icons/stop1-skipped.svg'">

                <img *ngIf="currentStopIndex == startStopIndex && busStopsDetails[startStopIndex].stopContext == 'OFFICE' && busStopsDetails[startStopIndex]?.actualArrivalTime != 0 "
                    [src]="imgSrc + 'assets/icons/stop1-crossed-office-current1.svg'">
                <img *ngIf="currentStopIndex == startStopIndex && busStopsDetails[startStopIndex].stopContext != 'OFFICE' && busStopsDetails[startStopIndex]?.actualArrivalTime != 0  && selectedCardIndex!=1 "
                    [src]="imgSrc + 'assets/icons/stop1-crossed-not-office-current1.svg'">

                <img *ngIf="currentStopIndex == startStopIndex && busStopsDetails[startStopIndex].stopContext != 'OFFICE' && busStopsDetails[startStopIndex]?.actualArrivalTime != 0 && selectedCardIndex===1"
                    [src]="imgSrc + 'assets/icons/stop1-crossed-office1.svg'" />
            </div>
            <div class="stop-card-child3 d-flex flex-dir-col just-space">
                <div class="d-flex just-space pr-16 " style="padding-top: 10px;">
                    <div class="d-flex flex-dir-col pb-8">
                        <span misToolTip [text]="busStopsDetails[startStopIndex]?.address" [position]="'right'"
                            style="max-width: 230px;"
                            class="h7-b truncate">{{busStopsDetails[startStopIndex]?.address}}</span>

                        <div class="d-flex gap-8"><span class="h8 grey">Planned
                                {{busStopsDetails[startStopIndex].formattedPlannedArrivalTime}}</span>
                            <!-- <span
                                class="h8 {{busStopsDetails[startStopIndex].actualColorClass}}">Actual:
                                {{busStopsDetails[startStopIndex].formattedActualArrivalTime}}</span> -->
                        </div>
                    </div>

                    <div class="d-flex just-center align-center gap-4" misToolTip [text]="'Stop reach time'"
                        [position]="'bottom'"
                        [ngClass]="busStopsDetails[startStopIndex].arrivalTimeDiff > 0 ? 'delay':'on-time'">
                        <span
                            *ngIf="busStopsDetails[startStopIndex].arrivalTimeDiff > 0 && !busStopsDetails[startStopIndex].skipped"
                            class="h8 font-VT323">{{busStopsDetails[startStopIndex].formattedPlannedArrivalTime}}</span>
                        <span
                            *ngIf="busStopsDetails[startStopIndex].arrivalTimeDiff > 0 && !busStopsDetails[startStopIndex].skipped"
                            class="h8 red-text font-VT323">(+{{busStopsDetails[startStopIndex].arrivalTimeDiffFormatted}})
                        </span>
                        <span *ngIf="busStopsDetails[startStopIndex].arrivalTimeDiff <= 0"
                            class="h8 green-text font-VT323">{{busStopsDetails[startStopIndex].formattedActualArrivalTime}}</span>
                        <span
                            *ngIf="busStopsDetails[startStopIndex].arrivalTimeDiff > 0 && busStopsDetails[startStopIndex].skipped"
                            class="h8 font-VT323">Stop Skipped</span>
                    </div>

                </div>
                <!-- *ngIf="busStopsDetails[startStopIndex].stopContext != 'OFFICE'" -->
                <div class="d-flex just-space align-center stop-card-bottom">
                    <div class="d-flex gap-16">
                        <div *ngIf="(busStopsDetails[startStopIndex].numberOfEmployeestoBoard > 0)" class="d-flex"><img
                                [src]="imgSrc + 'assets/icons/sign-in.svg'" style="margin-right:4px"> <span
                                class="h8 no-wrap">{{busStopsDetails[startStopIndex].numberOfEmployeesBoarded}}/{{busStopsDetails[startStopIndex].numberOfEmployeestoBoard}}
                            </span></div>
                        <div *ngIf="(busStopsDetails[startStopIndex].totalNumberOfNoShowEmployees > 0)" class="d-flex">
                            <img [src]="imgSrc + 'assets/icons/cancel.svg'" style="margin-right: 4px;"><span
                                class="h8 no-wrap">{{busStopsDetails[startStopIndex].totalNumberOfNoShowEmployees}}</span>
                        </div>
                        <div *ngIf="(busStopsDetails[startStopIndex].adhocEmployees.length > 0)" class="d-flex">
                            <span class="h8 no-wrap"> Adhoc-
                                {{busStopsDetails[startStopIndex].adhocEmployees.length}}</span>
                        </div>
                    </div>
                    <div *ngIf="busStopsDetails[startStopIndex].employees.length != 0"
                        (click)="toggleCard(busStopsDetails[startStopIndex].index)"
                        class="arrow-icons d-flex pointer-cursor">
                        <img [src]="imgSrc + 'assets/icons/line-down-arrow.svg'">
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="selectedCardIndex === busStopsDetails[startStopIndex].index" style="position: relative"
            [ngClass]="currentStopIndex == startStopIndex?'highlight-stop':''">
            <app-employee-card [@expandCollapse]="selectedCardIndex !== -1 ? 'expanded' : 'collapsed'"
                (openEmployee)="openEmployeePopup($event)"
                [employees]="busStopsDetails[startStopIndex].employees"></app-employee-card>

            <img *ngIf="currentStopIndex == startStopIndex" src="{{imgSrc}}assets/icons/bus1.svg"
                style="position: absolute;left:7px;bottom:0" />

        </div>
    </div>



    <!-- COLLAPSE STOP CROSSED CARDS -->
    <div *ngIf="currentStopIndex != startStopIndex && (this.currentStopIndex !== -1) && ((currentStopIndex - startStopIndex)-1) !=0"
        [ngClass]="{'bg-color-selected':expandedStopCrossed==true}" class="collapse-stops-card d-flex"
        style="padding-left:10px ;">

        <div class="collapse-stop-card-child2" *ngIf="!expandedStopCrossed">
            <img src="{{imgSrc}}assets/icons/multi-stop-crossed1.svg">
        </div>

        <div class="collapse-stop-card-child2" *ngIf="expandedStopCrossed">
            <img src="{{imgSrc}}assets/icons/multi-stops-crossed-expanded1.svg">
        </div>


        <div class="collapse-stop-card-child3" style="height: 48px;padding-top: 0;">
            <div class="collapse-border-bottom d-flex align-center just-space">
                <div>
                    <span class="h6-b">{{ (currentStopIndex - startStopIndex)-1 }} Stops</span>
                    <span *ngIf="stopsSkipped > 0 && !firstStopSkipped" class="h8" style="margin-left:33px">
                        {{stopsSkipped}}
                        Skipped</span>
                </div>


                <!-- <div>
                    <div class="d-flex gap-12"></div>

                </div> -->
                <div (click)="expandStopCrossed()" class="arrow-icons pointer-cursor"> <img
                        [@rotateArrow]="expandedStopCrossed ? 'expanded' : 'collapsed'"
                        src="{{imgSrc}}assets/icons/line-down-arrow.svg" alt="">
                </div>
            </div>
        </div>
    </div>


    <!-- EXPAND STOP CROSSED COLLAPSED CARDS -->
    <div [@expandCollapse]="expandedStopCrossed ? 'expanded' : 'collapsed'" style="padding-left:10px ;">
        <div *ngFor="let item of busStopsDetails.slice(startStopIndex+1,currentStopIndex);"
            class="d-flex flex-dir-col collapsed-bg">
            <div class="stop-card d-flex" style="position:relative;">

                <span class="h8 card-index reached-stop" [ngStyle]="{left:item.index>9?'14px':''}"> {{ item.index
                    }}</span>

                <div class="stop-card-child2">
                    <img *ngIf="!item.skipped" src="{{imgSrc}}assets/icons/stop-crossed-in-middle1.svg">
                    <img *ngIf="item.skipped" src="{{imgSrc}}assets/icons/stop-skipped.svg">
                </div>
                <div class="stop-card-child3 d-flex flex-dir-col just-space"
                    style="padding-top:18px;padding-left: 20px;">
                    <div class="d-flex just-space pr-16 ">
                        <div class="d-flex flex-dir-col pb-8">
                            <span misToolTip [text]="item.index" [position]="'right'" style="max-width: 230px;"
                                class="h7-b truncate">{{item?.address}}</span>

                            <div class="d-flex gap-8"><span class="h8 grey">Planned
                                    {{item.formattedPlannedArrivalTime}}</span>
                                <!-- <span
                                    class="h8 {{item.actualColorClass}}">Actual:
                                    {{item.formattedActualArrivalTime}}</span> -->
                            </div>
                        </div>

                        <div class="d-flex just-center gap-4" *ngIf="!item.skipped" misToolTip
                            [text]="'Stop reach time'" [position]="'bottom'"
                            [ngClass]="item.arrivalTimeDiff > 0 ? 'delay':'on-time'">
                            <!-- <span *ngIf="item.arrivalTimeDiff > 0" class="h8">Delay</span>
                            <span *ngIf="item.arrivalTimeDiff > 0" class="h8 red-text">{{item.arrivalTimeDiffFormatted}}
                            </span>
                            <span *ngIf="item.arrivalTimeDiff <= 0" class="h8-b green-text">On Time</span> -->

                            <span *ngIf="item.arrivalTimeDiff > 0"
                                class="h8 font-VT323">{{item.formattedPlannedArrivalTime}}</span>
                            <span *ngIf="item.arrivalTimeDiff > 0"
                                class="h8 red-text font-VT323">(+{{item.arrivalTimeDiffFormatted}})
                            </span>
                            <span *ngIf="item.arrivalTimeDiff <= 0"
                                class="h8-b green-text font-VT323">{{item.formattedActualArrivalTime}}</span>

                        </div>
                        <div *ngIf="item.skipped">
                            <span class="h8 red-text">Stop Skipped</span>
                        </div>

                    </div>
                    <div class="d-flex just-space align-center stop-card-bottom">
                        <div class="d-flex gap-16">
                            <div *ngIf="(item.numberOfEmployeestoBoard > 0)" class="d-flex"><img
                                    src="{{imgSrc}}assets/icons/sign-in.svg" style="margin-right:4px ;"> <span
                                    class="h8 no-wrap">{{item.numberOfEmployeesBoarded}}/{{item.numberOfEmployeestoBoard}}
                                </span>
                            </div>
                            <div *ngIf="(item.numberOfEmployeestoBoard === 0)" class="d-flex"><img
                                    src="{{imgSrc}}assets/icons/sign-in.svg" style="margin-right:4px ;"> <span
                                    class="h8 no-wrap">0/0</span>
                            </div>
                            <div *ngIf="(item.totalNumberOfNoShowEmployees > 0)" class="d-flex"><img
                                    src="{{imgSrc}}assets/icons/cancel.svg" style="margin-right:4px ;"><span
                                    class="h8 no-wrap">{{item.totalNumberOfNoShowEmployees}}</span>
                            </div>
                            <div *ngIf="(item.adhocEmployees.length > 0)" class="d-flex">
                                <span class="h8 no-wrap"> Adhoc - {{item.adhocEmployees.length}}</span>
                            </div>
                        </div>
                        <div *ngIf="item.employees.length != 0" class="arrow-icons d-flex pointer-cursor"
                            (click)="toggleCard(item.index)">
                            <img src="{{imgSrc}}assets/icons/line-down-arrow.svg">
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="selectedCardIndex === item.index">
                <app-employee-card [@expandCollapse]="selectedCardIndex !== -1 ? 'expanded' : 'collapsed'"
                    (openEmployee)="openEmployeePopup($event)" [employees]="item.employees"></app-employee-card>
            </div>

        </div>


    </div>



    <!-- CURRENT CARD -->
    <div *ngIf="(currentStopIndex != startStopIndex) && (currentStopIndex !== this.lastStopIndex) && (this.currentStopIndex !== -1)"
        class="d-flex flex-dir-col highlight-stop" style="padding-left:10px ;">

        <div class="stop-card d-flex " style="position: relative;">

            <span class="h8 card-index reached-stop"
                [ngStyle]="{left:busStopsDetails[currentStopIndex].index>9?'14px':''}">{{busStopsDetails[currentStopIndex].index}}</span>

            <div class="stop-card-child2" *ngIf="selectedCardIndex!==busStopsDetails[currentStopIndex].index">
                <img src="{{imgSrc}}assets/icons/middle-stop-crossed1.svg">
            </div>
            <div class="stop-card-child2" *ngIf="selectedCardIndex===busStopsDetails[currentStopIndex].index">
                <img src="{{imgSrc}}assets/icons/middle-stop-crossed3.svg">
            </div>
            <div class="stop-card-child3 d-flex flex-dir-col just-space">
                <div class="d-flex just-space pr-16 " style="padding-top: 17px">
                    <div class="d-flex flex-dir-col pb-8">
                        <span misToolTip [text]="busStopsDetails[currentStopIndex]?.address" [position]="'right'"
                            style="max-width: 230px;"
                            class="h7-b truncate">{{busStopsDetails[currentStopIndex]?.address}}</span>

                        <div class="d-flex gap-8"><span class="h8 grey">Planned
                                {{busStopsDetails[currentStopIndex].formattedPlannedArrivalTime}}</span>
                            <!-- <span
                                class="h8 {{busStopsDetails[currentStopIndex].actualColorClass}}">Actual:
                                {{busStopsDetails[currentStopIndex].formattedActualArrivalTime}}</span> -->
                        </div>
                    </div>

                    <div class="d-flex just-center gap-4" misToolTip [text]="'Stop reach time'" [position]="'bottom'"
                        [ngClass]="busStopsDetails[currentStopIndex].arrivalTimeDiff > 0 ? 'delay':'on-time'">
                        <!-- <span *ngIf="busStopsDetails[currentStopIndex].arrivalTimeDiff > 0" class="h8">Delay</span> -->
                        <!-- <span *ngIf="busStopsDetails[currentStopIndex].arrivalTimeDiff > 0"
                            class="h8 red-text">{{busStopsDetails[currentStopIndex].arrivalTimeDiffFormatted}} </span>
                        <span *ngIf="busStopsDetails[currentStopIndex].arrivalTimeDiff <= 0" class="h8-b green-text">On
                            Time</span> -->
                        <!-- <p>{{busStopsDetails[currentStopIndex].arrivalTimeDiff}}</p> -->
                        <span *ngIf="busStopsDetails[currentStopIndex].arrivalTimeDiff > 0"
                            class="h8 font-VT323">{{busStopsDetails[currentStopIndex].formattedPlannedArrivalTime}}</span>
                        <span *ngIf="busStopsDetails[currentStopIndex].arrivalTimeDiff > 0"
                            class="h8 red-text font-VT323">(+{{busStopsDetails[currentStopIndex].arrivalTimeDiffFormatted}})
                        </span>
                        <span *ngIf="busStopsDetails[currentStopIndex].arrivalTimeDiff === 0"
                            class="h8 green-text font-VT323">--</span>
                        <span *ngIf="busStopsDetails[currentStopIndex].arrivalTimeDiff <= 0"
                            class="h8-b green-text font-VT323">{{busStopsDetails[currentStopIndex].formattedActualArrivalTime}}</span>
                    </div>
                </div>
                <div class="d-flex just-space align-center stop-card-bottom">
                    <div class="d-flex gap-16">
                        <div *ngIf="(busStopsDetails[currentStopIndex].numberOfEmployeestoBoard > 0)" class="d-flex">
                            <img src="{{imgSrc}}assets/icons/sign-in.svg" style="margin-right: 4px;"> <span
                                class="h8 no-wrap">{{busStopsDetails[currentStopIndex].numberOfEmployeesBoarded}}/{{busStopsDetails[currentStopIndex].numberOfEmployeestoBoard}}
                            </span>
                        </div>
                        <div *ngIf="(busStopsDetails[currentStopIndex].totalNumberOfNoShowEmployees > 0)"
                            class="d-flex gap-4"><img src="{{imgSrc}}assets/icons/cancel.svg"><span
                                class="h8 no-wrap">{{busStopsDetails[currentStopIndex].totalNumberOfNoShowEmployees}}</span>
                        </div>
                    </div>
                    <div *ngIf="busStopsDetails[currentStopIndex].employees.length != 0"
                        (click)="toggleCard(busStopsDetails[currentStopIndex].index)"
                        class="arrow-icons d-flex pointer-cursor">
                        <img src="{{imgSrc}}assets/icons/line-down-arrow.svg">
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="selectedCardIndex === busStopsDetails[currentStopIndex].index" style="position: relative;">
            <app-employee-card [@expandCollapse]="selectedCardIndex !== -1 ? 'expanded' : 'collapsed'"
                (openEmployee)="openEmployeePopup($event)"
                [employees]="busStopsDetails[currentStopIndex].employees"></app-employee-card>
            <img src="{{imgSrc}}assets/icons/bus1.svg" style="position: absolute;left:7px;bottom:0" />
        </div>
    </div>



    <!-- UPCOMING CARD  && !((this.currentStopIndex==this.lastStopIndex) && (this.startStopIndex == this.upcomingStopIndex)) -->
    <div *ngIf="(upcomingStopIndex != lastStopIndex) &&  (this.currentStopIndex !== this.lastStopIndex) && (this.currentStopIndex !== -1) "
        class="d-flex flex-dir-col highlight-stop" style="padding-left:10px ;">
        <div class="stop-card d-flex" style="position: relative;">
            <!-- <div class="stop-card-child1">
                <span class="h8">Stop {{busStopsDetails[upcomingStopIndex].index}}</span>
            </div> -->
            <span class="h8 card-index"
                [ngStyle]="{left:busStopsDetails[upcomingStopIndex].index>9?'14px':''}">{{busStopsDetails[upcomingStopIndex].index}}</span>
            <div class="stop-card-child2">

                <img src="{{imgSrc}}assets/icons/stop-not-crossed1.svg">
            </div>
            <div class="stop-card-child3 d-flex flex-dir-col just-space">
                <div class="d-flex just-space pr-16 pt-15" style="align-items: baseline;">
                    <div class="d-flex flex-dir-col pb-8">
                        <span misToolTip [text]="busStopsDetails[upcomingStopIndex]?.address" [position]="'right'"
                            style="max-width: 230px;" class="h7-b truncate">
                            {{busStopsDetails[upcomingStopIndex]?.address}}</span>

                        <div class="d-flex gap-8"><span class="h8 grey">Planned
                                {{busStopsDetails[upcomingStopIndex].formattedPlannedArrivalTime}}</span>
                            <!-- <span
                                class="h8 {{busStopsDetails[upcomingStopIndex].actualColorClass}}">Actual:
                                {{busStopsDetails[upcomingStopIndex].formattedActualArrivalTime}}</span> -->
                        </div>
                    </div>

                    <div class="d-flex just-center align-center gap-4" misToolTip [text]="'Stop reach time'"
                        [position]="'bottom'"
                        [ngClass]="busStopsDetails[upcomingStopIndex].arrivalTimeDiff > 0 ? 'delay':'on-time'">

                        <!-- <span *ngIf="busStopsDetails[upcomingStopIndex].arrivalTimeDiff > 0" class="h8">Delay</span> -->
                        <span
                            class="h8 text-green font-VT323">--
                        </span>
                        <!-- <span *ngIf="busStopsDetails[upcomingStopIndex].arrivalTimeDiff <= 0" class="h8-b green-text">On
                            Time</span> -->


                    </div>
                </div>
                <div class="d-flex just-space align-center stop-card-bottom">
                    <div class="d-flex gap-16">
                        <div *ngIf="(busStopsDetails[upcomingStopIndex].numberOfEmployeestoBoard > 0)"
                            class="d-flex gap-4">
                            <img src="{{imgSrc}}assets/icons/sign-in.svg"> <span
                                class="h8 no-wrap">{{busStopsDetails[upcomingStopIndex].numberOfEmployeesBoarded}}/{{busStopsDetails[upcomingStopIndex].numberOfEmployeestoBoard}}
                            </span>
                        </div>
                        <div *ngIf="(busStopsDetails[upcomingStopIndex].totalNumberOfNoShowEmployees > 0)"
                            class="d-flex gap-4"><img src="{{imgSrc}}assets/icons/cancel.svg"><span
                                class="h8 no-wrap">{{busStopsDetails[upcomingStopIndex].totalNumberOfNoShowEmployees}}
                            </span>
                        </div>
                    </div>
                    <div *ngIf="busStopsDetails[upcomingStopIndex].employees.length != 0"
                        (click)="toggleCard(busStopsDetails[upcomingStopIndex].index)"
                        class="arrow-icons d-flex pointer-cursor">
                        <img src="{{imgSrc}}assets/icons/line-down-arrow.svg">
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="selectedCardIndex === busStopsDetails[upcomingStopIndex].index">
            <app-employee-card [@expandCollapse]="selectedCardIndex !== -1 ? 'expanded' : 'collapsed'"
                [employees]="busStopsDetails[upcomingStopIndex].employees"
                (openEmployee)="openEmployeePopup($event)"></app-employee-card>
        </div>

    </div>






    <!-- COLLAPSE VIEW OF UPCOMING CARDS -->
    <div *ngIf="hideUpcomingCollapse && (currentStopIndex != lastStopIndex)" style="padding-left:10px ;"
        [ngClass]="{'bg-color-selected':expandedStopComing==true}" class="upcoming-collapse-stops-card d-flex">
        <!-- <div class="collapse-stop-card-child1">
            <span class="h8"></span>
        </div> -->

        <div class="collapse-stop-card-child2" *ngIf="!expandedStopComing">
            <img src="{{imgSrc}}assets/icons/incoming-stops1.svg">
        </div>
        <div class="collapse-stop-card-child2" *ngIf="expandedStopComing"
            style="padding-left: 17px;padding-right: 27px;">
            <img src="{{imgSrc}}assets/icons/upcoming-stops-expanded.svg">
        </div>

        <div class="collapse-stop-card-child3  d-flex flex-dir-col collapse-border-bottom">
            <div class="d-flex just-space">
                <span class="h6-b">{{ (lastStopIndex - upcomingStopIndex) -1 }} Stops</span>
                <div (click)="expandStopComing()" class="arrow-icons pointer-cursor"><img
                        [@rotateArrow]="expandedStopComing ? 'expanded' : 'collapsed'"
                        src="{{imgSrc}}assets/icons/line-down-arrow.svg" alt=""></div>
            </div>
        </div>
    </div>


    <!-- EXPAND COLLAPSED UPCOMING CARD -->
    <div [@expandCollapse]="expandedStopComing ? 'expanded' : 'collapsed'" style="padding-left:10px ;">
        <div class="d-flex flex-dir-col collapsed-bg"
            *ngFor="let item2 of busStopsDetails.slice(upcomingStopIndex+1,lastStopIndex);">
            <div class="stop-card d-flex" style="position: relative;">
                <!-- <div class="stop-card-child1">
                    <span class="h8"> {{ item2.index > 1 ? 'Stops' : 'Stop' }} {{ item2.index }}</span>
                </div> -->
                <span class="h8 card-index" [ngStyle]="{left:item2.index>9?'14px':''}">{{ item2.index }}</span>
                <div class="stop-card-child2">
                    <img src="{{imgSrc}}assets/icons/stop-not-crossed1.svg">
                </div>
                <div class="stop-card-child3 d-flex flex-dir-col just-space" style="padding-left:20px">
                    <div class="d-flex just-space pr-16 " style="padding-top:17px;align-items: baseline;">
                        <div class="d-flex flex-dir-col pb-8">
                            <span misToolTip [text]="item2?.address" [position]="'right'" style="max-width: 230px;"
                                class="h7-b truncate">{{item2?.address}}</span>

                            <div class="d-flex gap-8"><span class="h8 grey">Planned
                                    {{item2.formattedPlannedArrivalTime}}</span>
                                <!-- <span
                                    class="h8 {{item2.actualColorClass}}">Actual:
                                    {{item2.formattedActualArrivalTime}}</span> -->
                            </div>
                        </div>

                        <div class="d-flex just-center align-center gap-4" misToolTip [text]="'Stop reach time'"
                            [position]="'bottom'" [ngClass]="item2.arrivalTimeDiff > 0 ? 'delay':'on-time'">
                            <!-- <span *ngIf="item2.arrivalTimeDiff > 0" class="h8">Delay</span> -->
                            <span class="h8 text-green font-VT323">-- </span>
                            <!-- <span *ngIf="item2.arrivalTimeDiff <= 0" class="h8-b green-text">On Time</span> -->
                        </div>
                    </div>
                    <div class="d-flex just-space align-center stop-card-bottom">
                        <div class="d-flex gap-16">
                            <div *ngIf="(item2.numberOfEmployeestoBoard > 0)" class="d-flex gap-4"><img
                                    src="{{imgSrc}}assets/icons/sign-in.svg"> <span
                                    class="h8 no-wrap">{{item2.numberOfEmployeesBoarded}}/{{item2.numberOfEmployeestoBoard}}
                                </span></div>
                            <div *ngIf="(item2.totalNumberOfNoShowEmployees > 0)" class="d-flex gap-4"><img
                                    src="{{imgSrc}}assets/icons/cancel.svg"><span class="h8 no-wrap">
                                    {{item2.totalNumberOfNoShowEmployees}}</span></div>
                        </div>
                        <div *ngIf="item2.employees.length != 0" class="arrow-icons d-flex pointer-cursor"
                            (click)="toggleCard(item2.index)">
                            <img src="{{imgSrc}}assets/icons/line-down-arrow.svg">
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="selectedCardIndex === item2.index">
                <app-employee-card [@expandCollapse]="selectedCardIndex !== -1 ? 'expanded' : 'collapsed'"
                    [employees]="item2.employees" (openEmployee)="openEmployeePopup($event)"></app-employee-card>
            </div>
        </div>
    </div>



    <!-- OFFICE STOP  or LAST STOP -->
    <div class="d-flex flex-dir-col" style="padding-left:10px ;">
        <div class="stop-card d-flex" style="position: relative;">
            <!-- <div class="stop-card-child1">
                <span *ngIf="busStopsDetails[lastStopIndex].stopContext != 'OFFICE'" class="h8">Stop
                    {{busStopsDetails[lastStopIndex].index}}</span>
                <span *ngIf="busStopsDetails[lastStopIndex].stopContext == 'OFFICE'" class="h8">Office</span>
            </div> -->
            <span
                [ngClass]="{'office-last-stop-reached':(busStopsDetails[lastStopIndex].stopContext == 'OFFICE' && busStopsDetails[lastStopIndex]?.actualArrivalTime != 0 ),
            'office-last-stop-not-reached':(busStopsDetails[lastStopIndex].stopContext == 'OFFICE' && busStopsDetails[lastStopIndex]?.actualArrivalTime == 0 ),
                        'not-reached-last-stop':(busStopsDetails[lastStopIndex].stopContext != 'OFFICE' && busStopsDetails[lastStopIndex]?.actualArrivalTime == 0 ),
                         'reached-stop':(busStopsDetails[lastStopIndex].stopContext != 'OFFICE' && busStopsDetails[lastStopIndex]?.actualArrivalTime != 0),
                         'reached-stop-text':(busStopsDetails[lastStopIndex].stopContext != 'OFFICE' && busStopsDetails[lastStopIndex]?.actualArrivalTime != 0)}"
                class="h8 card-index" [ngStyle]="{left:busStopsDetails[lastStopIndex].index>9?'14px':''}">{{
                busStopsDetails[lastStopIndex].index }}</span>
            <div class="stop-card-child2">
                <img *ngIf="busStopsDetails[lastStopIndex].stopContext == 'OFFICE' && busStopsDetails[lastStopIndex]?.actualArrivalTime == 0 "
                    src="{{imgSrc}}assets/icons/last-stop-not-reached-office1.svg">
                <img *ngIf="busStopsDetails[lastStopIndex].stopContext == 'OFFICE' && busStopsDetails[lastStopIndex]?.actualArrivalTime != 0 "
                    src="{{imgSrc}}assets/icons/last-stop-office-reached1.svg">
                <img *ngIf="busStopsDetails[lastStopIndex].stopContext != 'OFFICE' && busStopsDetails[lastStopIndex]?.actualArrivalTime == 0 "
                    style="margin-left:-1px ;" src="{{imgSrc}}assets/icons/last-stop-not-reached1.svg">
                <img *ngIf="busStopsDetails[lastStopIndex].stopContext != 'OFFICE' && busStopsDetails[lastStopIndex]?.actualArrivalTime != 0 "
                    style="margin-left:-1px ;" src="{{imgSrc}}assets/icons/last-stop-reached1.svg">
            </div>

            <div class="stop-card-child3 d-flex flex-dir-col just-space">
                <div class="d-flex just-space pr-16 "
                    style="padding-top: 16px;border-bottom: 1px solid lightgray;align-items: baseline;">
                    <div class="d-flex flex-dir-col pb-8">
                        <span class="h7-b">{{busStopsDetails[lastStopIndex]?.address}}</span>

                        <div class="d-flex gap-8"><span class="h8 grey">Planned
                                {{busStopsDetails[lastStopIndex].formattedPlannedArrivalTime}}</span>
                            <!-- <span
                                class="h8 {{busStopsDetails[lastStopIndex].actualColorClass}}">Actual:
                                {{busStopsDetails[lastStopIndex].formattedActualArrivalTime}}</span> -->
                        </div>
                    </div>

                    <div class="d-flex just-center align-center gap-4" misToolTip [text]="'Stop reach time'"
                        [position]="'bottom'"
                        [ngClass]="busStopsDetails[lastStopIndex].arrivalTimeDiff > 0 ? 'delay':'on-time'">
                        <!-- <span *ngIf="busStopsDetails[lastStopIndex].arrivalTimeDiff > 0" class="h8">Delay</span> -->
                        <span *ngIf="response['tripDetails']['status']!=='Ended'"
                            class="h8 text-green font-VT323">--
                        </span>
                        <span
                            *ngIf="busStopsDetails[lastStopIndex].arrivalTimeDiff <= 0 && response['tripDetails']['status']==='Ended'"
                            class="h8 green-text font-VT323">{{busStopsDetails[lastStopIndex].formattedActualArrivalTime}}</span>
                        <span
                            *ngIf="busStopsDetails[lastStopIndex].arrivalTimeDiff > 0 && response['tripDetails']['status']==='Ended'"
                            class="h8 red-text font-VT323">{{busStopsDetails[lastStopIndex].formattedActualArrivalTime==='--'?tripEndTime:busStopsDetails[lastStopIndex].formattedActualArrivalTime}}</span>
                    </div>

                </div>
                <div *ngIf="busStopsDetails[lastStopIndex].stopContext != 'OFFICE' && false"
                    class="d-flex just-space align-center stop-card-bottom">
                    <div class="d-flex gap-16">
                        <div *ngIf="(busStopsDetails[lastStopIndex].numberOfEmployeestoBoard > 0)" class="d-flex gap-4">
                            <img src="{{imgSrc}}assets/icons/sign-in.svg"> <span
                                class="h8 no-wrap">{{busStopsDetails[lastStopIndex].numberOfEmployeesBoarded}}/{{busStopsDetails[lastStopIndex].numberOfEmployeestoBoard}}
                                boarded</span>
                        </div>
                        <div *ngIf="(busStopsDetails[lastStopIndex].totalNumberOfNoShowEmployees > 0)"
                            class="d-flex gap-4">
                            <img src="{{imgSrc}}assets/icons/cancel.svg"><span
                                class="h8 no-wrap">{{busStopsDetails[lastStopIndex].totalNumberOfNoShowEmployees}}</span>
                        </div>
                    </div>
                    <div *ngIf="busStopsDetails[startStopIndex].employees.length != 0"
                        (click)="toggleCard(busStopsDetails[lastStopIndex].index)"
                        class="arrow-icons d-flex pointer-cursor">
                        <img src="{{imgSrc}}assets/icons/line-down-arrow.svg">
                    </div>
                </div>
            </div>
        </div>

        <!-- <div *ngIf="selectedCardIndex === busStopsDetails[lastStopIndex].index">
            <app-employee-card [@expandCollapse]="selectedCardIndex !== -1 ? 'expanded' : 'collapsed'"
                [employees]="busStopsDetails[lastStopIndex].employees"></app-employee-card>
        </div> -->
    </div>






</div>


<div class="overlay" *ngIf="employeeInfo">
    <div class="popup">
        <h2 style="font-size: 20px;font-weight:bold;border-bottom:1px solid lightgray">Employee Details</h2>
        <a class="close" (click)="employeeInfo = false">&times;</a>
        <div class="content d-flex flex-dir-rol gap-8">
            <span style="font-size: 20px;">{{employeeDetailsInfo?.name}}</span>
            <img src="{{imgSrc}}assets/icons/Line.svg" style="height: 20px;" alt="">
            <span style="font-size: 20px;"> <img src="{{imgSrc}}assets/icons/call.svg"
                    style="margin-right: 14px" />{{getEmployeeHiddenText(employeeDetailsInfo , 'phone')}}</span>
        </div>
    </div>
</div>